<template>
  <div class="onboarding-layout">
    <div class="onboarding-progress-bar">
      <div class="progress-text">Step {{ currentStep }} of {{ totalSteps }}</div>
      <v-progress-linear
        :model-value="progressValue"
        color="primary"
        height="10"
        rounded
      ></v-progress-linear>
    </div>
    <div class="onboarding-title">
      Get Started with Structure
    </div>
    <router-view />
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useStore } from 'vuex';

const route = useRoute();
const store = useStore();

const isCaptureOnly = computed(() => store.state.authentication.customer_type === 'capture');

// Capture-only users skip the subscription step, so compress the 5-step sequence to 4.
const totalSteps = computed(() => isCaptureOnly.value ? 4 : (route.meta.totalSteps || 4));
const currentStep = computed(() => {
  const step = route.meta.step || 1;
  return isCaptureOnly.value && step > 2 ? step - 1 : step;
});

const progressValue = computed(() => (currentStep.value / totalSteps.value) * 100);
</script>

<style scoped lang="scss">
  @import "@/assets/styles/OnboardingLayout.scss"
</style>
